/**
 * 显示屏api
 * date:2022 03 29
 */
import httpRequest from '@/utils/request.js'
import qs from 'qs'

/** 获取网关列表 */
export const displayList = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/display/lst/' + way,
    params: {
      ...params
    }
  })
/** 显示屏时区 */
export const contentList = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/param',
    params: {
      ...params
    }
  })
/** 显示屏删除 */
export const displayDel = data =>
  httpRequest.httpdelete('/service/display/delete', data)
/** 显示屏配置日志删除 */
export const displayDelConfig = data =>
  httpRequest.httpdelete('/service/display/delConfig', data)

/** 显示屏上报规则 */
export const displayUpdateAppConfig = data =>
  httpRequest.httpPost('/service/display/updateAppConfig', data)
/** 显示屏网络参数 */
export const displayUpdateNetConfig = data =>
  httpRequest.httpPost('/service/display/updateNetConfig', data)
/** 更新显示屏基础信息 */
export const displayUpdate = data =>
  httpRequest.httpPost('/service/display/update', data)
/** 显示屏停止与更新 */
export const displayEdit = (data, way) =>
  httpRequest.httpPost('/service/display/edit/' + way, data)
/** 显示屏配置获取 */
export const displayGetDetailConfig = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/display/getDetailConfig/' + way,
    params: {
      ...params
    }
  })
/** 显示屏日志获取 */
export const displayGetConfiglogList = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/display/getConfiglogList',
    params: {
      ...params
    }
  })
/** 显示屏详情 */
export const displayGetDisplayDetailInfo = id =>
  httpRequest.httpGet({
    url: 'service/display/getDisplayDetailInfo/' + id
  })
/** 显示屏新增 */
export const addDisplay = data =>
  httpRequest.httpPost('/service/display/addDisplay', data)
/** 显示屏编辑 */
export const editDisplay = data =>
  httpRequest.httpPost('/service/display/editDisplay', data)
// 导入显示屏
export const importDisplay = data =>
  httpRequest.httpPost('/service/display/importDisplay', data)

/**
 * 更新显示屏客户
 */
export const updateCustomer = data =>
  httpRequest.httpPost('/service/display/update/customer', qs.stringify(data))
